import { render, staticRenderFns } from "./FormItemSelectCarrier.vue?vue&type=template&id=2b69f886&"
import script from "./FormItemSelectCarrier.vue?vue&type=script&lang=js&"
export * from "./FormItemSelectCarrier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports